import { render, staticRenderFns } from "./scretDictionaryDetailModal.vue?vue&type=template&id=3900aa36"
import script from "./scretDictionaryDetailModal.vue?vue&type=script&lang=js"
export * from "./scretDictionaryDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports